import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _applyDecoratedDescriptor from '@babel/runtime/helpers/esm/applyDecoratedDescriptor';
import { extension, command, MarkExtension, ExtensionTag, isElementDomNode, ExtensionPriority, isString, omitExtraAttributes, joinStyles } from '@remirror/core';
import { palette } from '@remirror/extension-text-color';
import { ExtensionTextHighlightMessages } from '@remirror/messages';

var _excluded = ["highlight"];

var _dec, _dec2, _dec3, _class, _class2;
var setTextHighlightOptions = {
  icon: 'markPenLine',
  description: _ref => {
    var t = _ref.t;
    return t(ExtensionTextHighlightMessages.DESCRIPTION);
  },
  label: _ref2 => {
    var t = _ref2.t;
    return t(ExtensionTextHighlightMessages.LABEL);
  }
};
var TEXT_HIGHLIGHT_ATTRIBUTE = 'data-text-highlight-mark';
/**
 * Add a highlight color to the selected text (or text within a specified
 * range).
 */

var TextHighlightExtension = (_dec = extension({
  defaultOptions: {
    defaultHighlight: '',
    palette
  },
  staticKeys: ['defaultHighlight']
}), _dec2 = command(setTextHighlightOptions), _dec3 = command(), _dec(_class = (_class2 = class TextHighlightExtension extends MarkExtension {
  get name() {
    return 'textHighlight';
  }

  createTags() {
    return [ExtensionTag.FormattingMark, ExtensionTag.FontStyle];
  }

  createMarkSpec(extra, override) {
    var _override$parseDOM;

    return _objectSpread(_objectSpread({}, override), {}, {
      attrs: _objectSpread(_objectSpread({}, extra.defaults()), {}, {
        highlight: {
          default: this.options.defaultHighlight
        }
      }),
      parseDOM: [{
        tag: "span[".concat(TEXT_HIGHLIGHT_ATTRIBUTE, "]"),
        getAttrs: dom => {
          if (!isElementDomNode(dom)) {
            return;
          }

          var highlight = dom.getAttribute(TEXT_HIGHLIGHT_ATTRIBUTE);

          if (!highlight) {
            return;
          }

          return _objectSpread(_objectSpread({}, extra.parse(dom)), {}, {
            highlight
          });
        }
      }, {
        tag: "span[".concat(TEXT_HIGHLIGHT_ATTRIBUTE, "]"),
        getAttrs: dom => {
          if (!isElementDomNode(dom)) {
            return;
          }

          var highlight = dom.getAttribute(TEXT_HIGHLIGHT_ATTRIBUTE);

          if (!highlight) {
            return;
          }

          return _objectSpread(_objectSpread({}, extra.parse(dom)), {}, {
            highlight
          });
        }
      }, {
        // Get the color from the css style property. This is useful for pasted content.
        style: 'background-color',
        priority: ExtensionPriority.Low,
        getAttrs: highlight => {
          if (!isString(highlight)) {
            return;
          }

          return {
            highlight
          };
        }
      }, ...((_override$parseDOM = override.parseDOM) !== null && _override$parseDOM !== void 0 ? _override$parseDOM : [])],
      toDOM: mark => {
        var _omitExtraAttributes = omitExtraAttributes(mark.attrs, extra),
            highlight = _omitExtraAttributes.highlight,
            other = _objectWithoutProperties(_omitExtraAttributes, _excluded);

        var extraAttrs = extra.dom(mark);
        var style = extraAttrs.style;

        if (highlight) {
          style = joinStyles({
            backgroundColor: highlight
          }, style);
        }

        return ['mark', _objectSpread(_objectSpread(_objectSpread({}, other), extraAttrs), {}, {
          style,
          [TEXT_HIGHLIGHT_ATTRIBUTE]: highlight
        }), 0];
      }
    });
  }
  /**
   * Set the text highlight color value for the selected text.
   */


  setTextHighlight(highlight, options) {
    return this.store.commands.applyMark.original(this.type, {
      highlight
    }, options === null || options === void 0 ? void 0 : options.selection);
  }
  /**
   * Remove the highlight mark from the selection.
   */


  removeTextHighlight(options) {
    return this.store.commands.removeMark.original(_objectSpread(_objectSpread({
      type: this.type
    }, options), {}, {
      expand: true
    }));
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "setTextHighlight", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "setTextHighlight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeTextHighlight", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "removeTextHighlight"), _class2.prototype)), _class2)) || _class);

export { TextHighlightExtension };
